import api from "api/api";

export async function fetchEntityInvoiceInformation(entityId: number, signal?: AbortSignal): Promise<string> {
  const response = await api.get<string>(`/api/entity/${entityId}/invoiceInformation`, { signal });
  return response.data;
}
